module.exports = __webpack_public_path__ + "static/media/banner-ibrd-8.e72411d3.png";